import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { withTranslation } from "react-i18next";

import moment from "moment";
import { get } from "lodash";

import { Col, Row } from "reactstrap";

import Collapse from "Components/Common/ViewApplicationDetailComponents/Collapse";

const ViewMockScheduleData = ({ mockDrillData, isExpandable = true, t }) => {
  const { mockDrillDetail } = mockDrillData || {};

  const { proposedDrillDate, time } = mockDrillDetail || {};

  const fields = useMemo(
    () => [
      {
        name: "Proposed Drill Date",
        renderField: () =>
          proposedDrillDate
            ? moment(proposedDrillDate).format("DD-MM-YYYY")
            : "N/A",
      },
      {
        name: "Time",
        renderField: () => (time ? moment(time).format("HH:mm") : "N/A"),
      },
      {
        name: "scenario",
        key: "scenario",
      },
    ],
    [mockDrillDetail]
  );

  return (
    <>
      <Collapse title="Mock Drill Details" isExpandable={isExpandable}>
        <Row className="d-flex  mb-2">
          {fields.map(({ name, key, isRequired, renderField }) => {
            const value = get(mockDrillDetail, key, "");
            return (
              <Col key={key} lg={6} className="mb-1">
                <Row>
                  <Col md={5}>{t(name)}:</Col>
                  <Col
                    md={7}
                    className="fw-semibold"
                    style={{ wordBreak: "break-word" }}
                  >
                    {renderField
                      ? renderField(value)
                      : get(mockDrillDetail, key, null) ??
                        (isRequired ? "-" : "N/A")}
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Collapse>
    </>
  );
};

ViewMockScheduleData.propTypes = {
  mockDrillDetail: PropTypes.object,
  isExpandable: PropTypes.bool,
  accessCardHolderType: PropTypes.number,
  t: PropTypes.func,
};

export default withTranslation()(ViewMockScheduleData);
